import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoTiktok = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.053 6.21a1 1 0 0 0-2 0v9.474c0 .279-.092.719-.338 1.06-.21.291-.567.572-1.294.572-1.002 0-1.48-.378-1.746-.758-.307-.438-.412-1.005-.412-1.4 0-.5.605-1.632 2.158-1.632a1 1 0 1 0 0-2c-2.657 0-4.158 2.027-4.158 3.632 0 .657.159 1.67.773 2.547.655.936 1.756 1.61 3.385 1.61 1.379 0 2.337-.596 2.917-1.402.543-.755.715-1.63.715-2.229V9.786l.128.067c1.109.56 2.378.611 3.206.508a1 1 0 0 0-.248-1.985c-.575.072-1.411.018-2.057-.308a1.79 1.79 0 0 1-.725-.633c-.17-.267-.304-.652-.304-1.224Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 7a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7Zm5-3h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLogoTiktok;
